export const MOBILE_ACCOUNT_TYPE = 'io.minga.app';
